import type { JsonObject, SaveFeedbackByCoopResponse } from '@/app-package';
import type { FeedbackDoc } from '@bb/domain/dist/schemas';
import type { AxiosRequestConfig } from 'axios';
import axios from 'axios';

export type SaveFeedbackByCoopOptions = {
  listingId: string;
  appointmentId: string;
  feedback: JsonObject<
    Omit<
      FeedbackDoc,
      '_id' | 'id' | 'submittedAt' | 'createdAt' | 'updatedAt'
    > & { id?: string; coopSubmitted?: boolean }
  >;
};

const saveFeedbackByCoop = async ({
  listingId,
  appointmentId,
  feedback,
}: SaveFeedbackByCoopOptions) => {
  const config: AxiosRequestConfig = {
    url: `/user/coop/listing/${listingId}/appointment/${appointmentId}/feedback`,
    method: 'post',
    data: { feedback },
  };

  await axios.request<SaveFeedbackByCoopResponse>(config);
};

export default saveFeedbackByCoop;
